import { render, staticRenderFns } from "./PowraG.vue?vue&type=template&id=02d4f976&scoped=true&"
import script from "./PowraG.vue?vue&type=script&lang=js&"
export * from "./PowraG.vue?vue&type=script&lang=js&"
import style0 from "./PowraG.vue?vue&type=style&index=0&id=02d4f976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4f976",
  null
  
)

export default component.exports